import styled, { css } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "ProductCardSkeletonstyles__Wrapper",
  componentId: "sc-1id8e4v-0"
})(["flex-direction:column;position:relative;padding:15px 0px;display:block;margin-bottom:-1px;", ""], function (props) {
  return css(["@media only screen and (max-width:", "){padding:15px;}"], props.theme.size.breakpoint['max-width'].xs);
});
export { Wrapper };